import React, { useState } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  ListItemButton,
  Link,
  Menu,
  MenuItem,
  Card,
  CardContent,
  Stack
} from '@mui/material';
import {
  Layers,
  ExpandLess,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Bluetooth,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Structure des données hiérarchisées
const householdData = {
  "title": "Répartition des ménages ordinaires par milieu de résidence, province et commune selon les ménages agricoles et leur taille moyenne",
  "provinces": [
    {
      "name": "BURUNDI",
      "communes": [],
      "effectif": "2 724 457",
      "tailleMoyenne": "4,5",
      "menageAgricole": "2 335 995",
      "pourcentageAgricole": "85,7",
      "menageNonAgricole": "388 462",
      "pourcentageNonAgricole": "14,3"
    },
    {
      "name": "URBAIN",
      "communes": [],
      "effectif": "688 425",
      "tailleMoyenne": "4,3",
      "menageAgricole": "390 809",
      "pourcentageAgricole": "56,8",
      "menageNonAgricole": "297 616",
      "pourcentageNonAgricole": "43,2"
    },
    {
      "name": "RURAL",
      "communes": [],
      "effectif": "2 036 032",
      "tailleMoyenne": "4,5",
      "menageAgricole": "1 945 186",
      "pourcentageAgricole": "95,5",
      "menageNonAgricole": "90 846",
      "pourcentageNonAgricole": "4,5"
    },
    {
      "name": "BUHUMUZA",
      "communes": [
        {
          "name": "BUTAGANZWA",
          "effectif": "22 752",
          "tailleMoyenne": "4,8",
          "menageAgricole": "22 561",
          "pourcentageAgricole": "99,2",
          "menageNonAgricole": "191",
          "pourcentageNonAgricole": "0,8"
        },
        {
          "name": "BUTIHINDA",
          "effectif": "99 533",
          "tailleMoyenne": "4,4",
          "menageAgricole": "94 324",
          "pourcentageAgricole": "94,8",
          "menageNonAgricole": "5 209",
          "pourcentageNonAgricole": "5,2"
        },
        {
          "name": "CANKUZO",
          "effectif": "33 695",
          "tailleMoyenne": "4,7",
          "menageAgricole": "29 782",
          "pourcentageAgricole": "88,4",
          "menageNonAgricole": "3 913",
          "pourcentageNonAgricole": "11,6"
        },
        {
          "name": "GISAGARA",
          "effectif": "61 910",
          "tailleMoyenne": "4,7",
          "menageAgricole": "59 004",
          "pourcentageAgricole": "95,3",
          "menageNonAgricole": "2 906",
          "pourcentageNonAgricole": "4,7"
        },
        {
          "name": "GISURU",
          "effectif": "70 165",
          "tailleMoyenne": "4,8",
          "menageAgricole": "68 822",
          "pourcentageAgricole": "98,1",
          "menageNonAgricole": "1 343",
          "pourcentageNonAgricole": "1,9"
        },
        {
          "name": "MUYINGA",
          "effectif": "107 593",
          "tailleMoyenne": "4,6",
          "menageAgricole": "98 570",
          "pourcentageAgricole": "91,6",
          "menageNonAgricole": "9 023",
          "pourcentageNonAgricole": "8,4"
        },
        {
          "name": "RUYIGI",
          "effectif": "45 701",
          "tailleMoyenne": "4,8",
          "menageAgricole": "43 005",
          "pourcentageAgricole": "94,1",
          "menageNonAgricole": "2 696",
          "pourcentageNonAgricole": "5,9"
        }
      ],
      "effectif": "441 349",
      "tailleMoyenne": "4,6",
      "menageAgricole": "416 068",
      "pourcentageAgricole": "94,3",
      "menageNonAgricole": "25 281",
      "pourcentageNonAgricole": "5,7"
    },
    {
      "name": "BUJUMBURA",
      "communes": [
        {
          "name": "BUBANZA",
          "effectif": "49 413",
          "tailleMoyenne": "4,8",
          "menageAgricole": "46 278",
          "pourcentageAgricole": "93,7",
          "menageNonAgricole": "3 135",
          "pourcentageNonAgricole": "6,3"
        },
        {
          "name": "BUKINANYANA",
          "effectif": "56 055",
          "tailleMoyenne": "4,8",
          "menageAgricole": "49 992",
          "pourcentageAgricole": "89,2",
          "menageNonAgricole": "6 063",
          "pourcentageNonAgricole": "10,8"
        },
        {
          "name": "CIBITOKE",
          "effectif": "56 085",
          "tailleMoyenne": "4,6",
          "menageAgricole": "46 824",
          "pourcentageAgricole": "83,5",
          "menageNonAgricole": "9 261",
          "pourcentageNonAgricole": "16,5"
        },
        {
          "name": "ISARE",
          "effectif": "30 603",
          "tailleMoyenne": "4,9",
          "menageAgricole": "29 400",
          "pourcentageAgricole": "96,1",
          "menageNonAgricole": "1 203",
          "pourcentageNonAgricole": "3,9"
        },
        {
          "name": "MPANDA",
          "effectif": "75 927",
          "tailleMoyenne": "4,7",
          "menageAgricole": "58 048",
          "pourcentageAgricole": "76,5",
          "menageNonAgricole": "17 879",
          "pourcentageNonAgricole": "23,5"
        },
        {
          "name": "MUGERE",
          "effectif": "110 077",
          "tailleMoyenne": "4,6",
          "menageAgricole": "58 479",
          "pourcentageAgricole": "53,1",
          "menageNonAgricole": "51 598",
          "pourcentageNonAgricole": "46,9"
        },
        {
          "name": "MUGINA",
          "effectif": "46 528",
          "tailleMoyenne": "4,8",
          "menageAgricole": "43 028",
          "pourcentageAgricole": "92,5",
          "menageNonAgricole": "3 500",
          "pourcentageNonAgricole": "7,5"
        },
        {
          "name": "MUHUTA",
          "effectif": "23 164",
          "tailleMoyenne": "5,1",
          "menageAgricole": "21 123",
          "pourcentageAgricole": "91,2",
          "menageNonAgricole": "2 041",
          "pourcentageNonAgricole": "8,8"
        },
        {
          "name": "MUKAZA",
          "effectif": "41 529",
          "tailleMoyenne": "3,8",
          "menageAgricole": "10 750",
          "pourcentageAgricole": "25,9",
          "menageNonAgricole": "30 779",
          "pourcentageNonAgricole": "74,1"
        },
        {
          "name": "NTAHANGWA",
          "effectif": "216 076",
          "tailleMoyenne": "4,2",
          "menageAgricole": "74 296",
          "pourcentageAgricole": "34,4",
          "menageNonAgricole": "141 780",
          "pourcentageNonAgricole": "65,6"
        },
        {
          "name": "RWIBAGA",
          "effectif": "24 526",
          "tailleMoyenne": "4,7",
          "menageAgricole": "23 536",
          "pourcentageAgricole": "96",
          "menageNonAgricole": "990",
          "pourcentageNonAgricole": "4"
        }
      ],
      "effectif": "729 983",
      "tailleMoyenne": "4,5",
      "menageAgricole": "461 754",
      "pourcentageAgricole": "63,3",
      "menageNonAgricole": "268 229",
      "pourcentageNonAgricole": "36,7"
    },
    {
      "name": "BURUNGA",
      "communes": [
        {
          "name": "BURURI",
          "effectif": "41 427",
          "tailleMoyenne": "4,4",
          "menageAgricole": "39 026",
          "pourcentageAgricole": "94,2",
          "menageNonAgricole": "2 401",
          "pourcentageNonAgricole": "5,8"
        },
        {
          "name": "MAKAMBA",
          "effectif": "77 682",
          "tailleMoyenne": "4,7",
          "menageAgricole": "73 331",
          "pourcentageAgricole": "94,4",
          "menageNonAgricole": "4 351",
          "pourcentageNonAgricole": "5,6"
        },
        {
          "name": "MATANA",
          "effectif": "43 656",
          "tailleMoyenne": "4,4",
          "menageAgricole": "41 587",
          "pourcentageAgricole": "95,3",
          "menageNonAgricole": "2 069",
          "pourcentageNonAgricole": "4,7"
        },
        {
          "name": "MUSONGATI",
          "effectif": "71 083",
          "tailleMoyenne": "4,7",
          "menageAgricole": "69 154",
          "pourcentageAgricole": "97,3",
          "menageNonAgricole": "1 929",
          "pourcentageNonAgricole": "2,7"
        },
        {
          "name": "NYANZA",
          "effectif": "76 562",
          "tailleMoyenne": "4,8",
          "menageAgricole": "67 924",
          "pourcentageAgricole": "88,7",
          "menageNonAgricole": "8 638",
          "pourcentageNonAgricole": "11,3"
        },
        {
          "name": "RUMONGE",
          "effectif": "87 538",
          "tailleMoyenne": "4,9",
          "menageAgricole": "75 454",
          "pourcentageAgricole": "86,2",
          "menageNonAgricole": "12 084",
          "pourcentageNonAgricole": "13,8"
        },
        {
          "name": "RUTANA",
          "effectif": "47 256",
          "tailleMoyenne": "4,8",
          "menageAgricole": "44 886",
          "pourcentageAgricole": "95",
          "menageNonAgricole": "2 370",
          "pourcentageNonAgricole": "5"
        }
      ],
      "effectif": "445 204",
      "tailleMoyenne": "4,7",
      "menageAgricole": "411 362",
      "pourcentageAgricole": "92,4",
      "menageNonAgricole": "33 842",
      "pourcentageNonAgricole": "7,6"
    },
    {
      "name": "BUTANYERERA",
      "communes": [
        {
          "name": "BUSONI",
          "effectif": "81 249",
          "tailleMoyenne": "4,4",
          "menageAgricole": "77 459",
          "pourcentageAgricole": "95,3",
          "menageNonAgricole": "3 790",
          "pourcentageNonAgricole": "4,7"
        },
        {
          "name": "KAYANZA",
          "effectif": "74 291",
          "tailleMoyenne": "4,4",
          "menageAgricole": "68 880",
          "pourcentageAgricole": "92,7",
          "menageNonAgricole": "5 411",
          "pourcentageNonAgricole": "7,3"
        },
        {
          "name": "KIREMBA",
          "effectif": "68 812",
          "tailleMoyenne": "4,2",
          "menageAgricole": "62 754",
          "pourcentageAgricole": "91,2",
          "menageNonAgricole": "6 058",
          "pourcentageNonAgricole": "8,8"
        },
        {
          "name": "KIRUNDO",
          "effectif": "109 939",
          "tailleMoyenne": "4,3",
          "menageAgricole": "103 803",
          "pourcentageAgricole": "94,4",
          "menageNonAgricole": "6 136",
          "pourcentageNonAgricole": "5,6"
        },
        {
          "name": "MATONGO",
          "effectif": "61 202",
          "tailleMoyenne": "4,3",
          "menageAgricole": "60 019",
          "pourcentageAgricole": "98,1",
          "menageNonAgricole": "1 183",
          "pourcentageNonAgricole": "1,9"
        },
        {
          "name": "MUHANGA",
          "effectif": "55 175",
          "tailleMoyenne": "4",
          "menageAgricole": "54 310",
          "pourcentageAgricole": "98,4",
          "menageNonAgricole": "865",
          "pourcentageNonAgricole": "1,6"
        },
        {
          "name": "NGOZI",
          "effectif": "76 729",
          "tailleMoyenne": "4,1",
          "menageAgricole": "65 917",
          "pourcentageAgricole": "85,9",
          "menageNonAgricole": "10 812",
          "pourcentageNonAgricole": "14,1"
        },
        {
          "name": "TANGARA",
          "effectif": "60 752",
          "tailleMoyenne": "4,3",
          "menageAgricole": "59 108",
          "pourcentageAgricole": "97,3",
          "menageNonAgricole": "1 644",
          "pourcentageNonAgricole": "2,7"
        }
      ],
      "effectif": "588 149",
      "tailleMoyenne": "4,3",
      "menageAgricole": "552 250",
      "pourcentageAgricole": "93,9",
      "menageNonAgricole": "35 899",
      "pourcentageNonAgricole": "6,1"
    },
    {
      "name": "GITEGA",
      "communes": [
        {
          "name": "BUGENDANA",
          "effectif": "54 013",
          "tailleMoyenne": "4,2",
          "menageAgricole": "53 246",
          "pourcentageAgricole": "98,6",
          "menageNonAgricole": "767",
          "pourcentageNonAgricole": "1,4"
        },
        {
          "name": "GISHUBI",
          "effectif": "59 031",
          "tailleMoyenne": "4,1",
          "menageAgricole": "57 900",
          "pourcentageAgricole": "98,1",
          "menageNonAgricole": "1 131",
          "pourcentageNonAgricole": "1,9"
        },
        {
          "name": "GITEGA",
          "effectif": "120 351",
          "tailleMoyenne": "4,3",
          "menageAgricole": "104 734",
          "pourcentageAgricole": "87",
          "menageNonAgricole": "15 617",
          "pourcentageNonAgricole": "13"
        },
        {
          "name": "KARUSI",
          "effectif": "82 400",
          "tailleMoyenne": "4,6",
          "menageAgricole": "80 754",
          "pourcentageAgricole": "98",
          "menageNonAgricole": "1 646",
          "pourcentageNonAgricole": "2"
        },
        {
          "name": "KIGANDA",
          "effectif": "34 087",
          "tailleMoyenne": "4,4",
          "menageAgricole": "33 267",
          "pourcentageAgricole": "97,6",
          "menageNonAgricole": "820",
          "pourcentageNonAgricole": "2,4"
        },
        {
          "name": "MURAMVYA",
          "effectif": "38 154",
          "tailleMoyenne": "4,4",
          "menageAgricole": "36 343",
          "pourcentageAgricole": "95,3",
          "menageNonAgricole": "1 811",
          "pourcentageNonAgricole": "4,7"
        },
        {
          "name": "MWARO",
          "effectif": "34 799",
          "tailleMoyenne": "4,2",
          "menageAgricole": "33 177",
          "pourcentageAgricole": "95,3",
          "menageNonAgricole": "1 622",
          "pourcentageNonAgricole": "4,7"
        },
        {
          "name": "NYABIHANGA",
          "effectif": "41 650",
          "tailleMoyenne": "4,2",
          "menageAgricole": "40 802",
          "pourcentageAgricole": "98",
          "menageNonAgricole": "848",
          "pourcentageNonAgricole": "2"
        },
        {
          "name": "SHOMBO",
          "effectif": "55 287",
          "tailleMoyenne": "4,6",
          "menageAgricole": "54 338",
          "pourcentageAgricole": "98,3",
          "menageNonAgricole": "949",
          "pourcentageNonAgricole": "1,7"
        }
      ],
      "effectif": "519 772",
      "tailleMoyenne": "4,3",
      "menageAgricole": "494 561",
      "pourcentageAgricole": "95,1",
      "menageNonAgricole": "25 211",
      "pourcentageNonAgricole": "4,9"
    }
  ],
  "total": {
    "effectif": "2 724 457",
    "tailleMoyenne": "4,5",
    "menageAgricole": "2 335 995",
    "pourcentageAgricole": "85,7",
    "menageNonAgricole": "388 462",
    "pourcentageNonAgricole": "14,3"
  },
  "urbain": {
    "effectif": "688 425",
    "tailleMoyenne": "4,3",
    "menageAgricole": "390 809",
    "pourcentageAgricole": "56,8",
    "menageNonAgricole": "297 616",
    "pourcentageNonAgricole": "43,2"
  },
  "rural": {
    "effectif": "2 036 032",
    "tailleMoyenne": "4,5",
    "menageAgricole": "1 945 186",
    "pourcentageAgricole": "95,5",
    "menageNonAgricole": "90 846",
    "pourcentageNonAgricole": "4,5"
  }
};

const AgriculturalHouseholdsPageProvCom = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  
  const handleCopyTable = () => {
    let tableContent = "Milieu/Province/Commune\tEffectif\tTaille Moyenne\tMénages Agricoles\t%\tMénages Non Agricoles\t%\n";
    
    // Ajout des données totales
    tableContent += `BURUNDI\t${householdData.total.effectif}\t${householdData.total.tailleMoyenne}\t${householdData.total.menageAgricole}\t${householdData.total.pourcentageAgricole}\t${householdData.total.menageNonAgricole}\t${householdData.total.pourcentageNonAgricole}\n`;
    tableContent += `URBAIN\t${householdData.urbain.effectif}\t${householdData.urbain.tailleMoyenne}\t${householdData.urbain.menageAgricole}\t${householdData.urbain.pourcentageAgricole}\t${householdData.urbain.menageNonAgricole}\t${householdData.urbain.pourcentageNonAgricole}\n`;
    tableContent += `RURAL\t${householdData.rural.effectif}\t${householdData.rural.tailleMoyenne}\t${householdData.rural.menageAgricole}\t${householdData.rural.pourcentageAgricole}\t${householdData.rural.menageNonAgricole}\t${householdData.rural.pourcentageNonAgricole}\n`;
    
    // Ajout des données par province et commune
    householdData.provinces.forEach(province => {
      tableContent += `${province.name}\t${province.effectif}\t${province.tailleMoyenne}\t${province.menageAgricole}\t${province.pourcentageAgricole}\t${province.menageNonAgricole}\t${province.pourcentageNonAgricole}\n`;
      
      province.communes.forEach(commune => {
        tableContent += `  ${commune.name}\t${commune.effectif}\t${commune.tailleMoyenne}\t${commune.menageAgricole}\t${commune.pourcentageAgricole}\t${commune.menageNonAgricole}\t${commune.pourcentageNonAgricole}\n`;
      });
    });
    
    navigator.clipboard.writeText(`${householdData.title}\n\n${tableContent}`)
      .then(() => alert('Tableau copié dans le presse-papier'))
      .catch(err => console.error('Erreur lors de la copie:', err));
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleProvince = (provinceName) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceName]: !prev[provinceName]
    }));
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };

  const shareVia = (method) => {
    handleMenuClose();
    const text = `Découvrez les données des ménages agricoles du Burundi: ${householdData.title}`;
    const url = window.location.href;
    
    switch(method) {
      case 'whatsapp':
        window.open(`https://wa.me/?text=${encodeURIComponent(text + ' ' + url)}`, '_blank');
        break;
      case 'email':
        window.open(`mailto:?subject=${encodeURIComponent(text)}&body=${encodeURIComponent(url)}`, '_blank');
        break;
      case 'bluetooth':
        alert(`Partage via Bluetooth simulé: ${text}`);
        break;
      default:
        if (navigator.share) {
          navigator.share({
            title: text,
            url: url
          }).catch(err => console.log('Erreur de partage:', err));
        } else {
          navigator.clipboard.writeText(url);
          alert('Lien copié dans le presse-papier');
        }
    }
  };

  const downloadFile = (format) => {
    handleMenuClose();
    const blob = new Blob([JSON.stringify(householdData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `menages-agricoles-burundi.${format}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    
    alert(`Téléchargement du fichier ${format} simulé`);
  };

  // Calcul des indicateurs clés
  const keyStats = {
    totalHouseholds: householdData.total.effectif,
    agriculturalPercentage: householdData.total.pourcentageAgricole,
    urbanAgriculturalPercentage: householdData.urbain.pourcentageAgricole,
    ruralAgriculturalPercentage: householdData.rural.pourcentageAgricole,
    highestAgriculturalProvince: householdData.provinces.reduce((max, province) => 
      parseFloat(province.pourcentageAgricole.replace(',', '.')) > parseFloat(max.pourcentageAgricole.replace(',', '.')) ? province : max
    ),
    lowestAgriculturalProvince: householdData.provinces.reduce((min, province) => 
      parseFloat(province.pourcentageAgricole.replace(',', '.')) < parseFloat(min.pourcentageAgricole.replace(',', '.')) ? province : min
    ),
    largestHouseholdSize: householdData.provinces.reduce((max, province) => 
      parseFloat(province.tailleMoyenne.replace(',', '.')) > parseFloat(max.tailleMoyenne.replace(',', '.')) ? province : max
    )
  };

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  const filteredProvinces = householdData.provinces.map(province => {
    if (!searchTerm) return province;
    
    const filteredCommunes = province.communes.filter(commune =>
      commune.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    
    return {
      ...province,
      communes: filteredCommunes,
      show: filteredCommunes.length > 0 || 
            province.name.toLowerCase().includes(searchTerm.toLowerCase())
    };
  }).filter(province => province.show || !searchTerm);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
        
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {householdData.title}
                    </Typography>
                  </Box>
                  <Grid container spacing={1} style={{ marginTop: '5px',marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6} ></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher province/commune..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés sur les Ménages Agricoles
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Ménages Totaux
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {householdData.total.effectif}
                              </Typography>
                              <Typography variant="caption">
                                dont {householdData.total.pourcentageAgricole}% agricoles
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Taille Moyenne
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {householdData.total.tailleMoyenne}
                              </Typography>
                              <Typography variant="caption">
                                personnes par ménage
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus forte proportion agricole
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.highestAgriculturalProvince.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.highestAgriculturalProvince.pourcentageAgricole}%
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Plus faible proportion agricole
                              </Typography>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.lowestAgriculturalProvince.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.lowestAgriculturalProvince.pourcentageAgricole}%
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des ménages agricoles">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Milieu/Province/Commune</TableCell>
                          <TableCell align="right">Effectif</TableCell>
                          <TableCell align="right">Taille Moyenne</TableCell>
                          <TableCell align="right">Ménages Agricoles</TableCell>
                          <TableCell align="right">%</TableCell>
                          <TableCell align="right">Ménages Non Agricoles</TableCell>
                          <TableCell align="right">%</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Ligne pour le total Burundi */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ fontWeight: 'bold' }}>
                            BURUNDI
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{householdData.total.effectif}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{householdData.total.tailleMoyenne}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{householdData.total.menageAgricole}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{householdData.total.pourcentageAgricole}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{householdData.total.menageNonAgricole}</TableCell>
                          <TableCell align="right" sx={{ fontWeight: 'bold' }}>{householdData.total.pourcentageNonAgricole}</TableCell>
                        </ProvinceRow>

                        {/* Lignes pour urbain et rural */}
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ pl: 4 }}>
                            URBAIN
                          </TableCell>
                          <TableCell align="right">{householdData.urbain.effectif}</TableCell>
                          <TableCell align="right">{householdData.urbain.tailleMoyenne}</TableCell>
                          <TableCell align="right">{householdData.urbain.menageAgricole}</TableCell>
                          <TableCell align="right">{householdData.urbain.pourcentageAgricole}</TableCell>
                          <TableCell align="right">{householdData.urbain.menageNonAgricole}</TableCell>
                          <TableCell align="right">{householdData.urbain.pourcentageNonAgricole}</TableCell>
                        </ProvinceRow>
                        
                        <ProvinceRow hover>
                          <TableCell component="th" scope="row" sx={{ pl: 4 }}>
                            RURAL
                          </TableCell>
                          <TableCell align="right">{householdData.rural.effectif}</TableCell>
                          <TableCell align="right">{householdData.rural.tailleMoyenne}</TableCell>
                          <TableCell align="right">{householdData.rural.menageAgricole}</TableCell>
                          <TableCell align="right">{householdData.rural.pourcentageAgricole}</TableCell>
                          <TableCell align="right">{householdData.rural.menageNonAgricole}</TableCell>
                          <TableCell align="right">{householdData.rural.pourcentageNonAgricole}</TableCell>
                        </ProvinceRow>

                        {/* Données par province et commune */}
                        {filteredProvinces.map((province, index) => (
                          <React.Fragment key={index}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.name)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row">
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.name] ? <ExpandLess /> : <ExpandMore />}
                                  {province.name}
                                </Box>
                              </TableCell>
                              <TableCell align="right">{province.effectif}</TableCell>
                              <TableCell align="right">{province.tailleMoyenne}</TableCell>
                              <TableCell align="right">{province.menageAgricole}</TableCell>
                              <TableCell align="right">{province.pourcentageAgricole}</TableCell>
                              <TableCell align="right">{province.menageNonAgricole}</TableCell>
                              <TableCell align="right">{province.pourcentageNonAgricole}</TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={7}>
                                <Collapse in={expandedProvinces[province.name] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune, idx) => (
                                        <CommuneRow key={idx} hover>
                                          <TableCell sx={{ pl: 6 }}>{commune.name}</TableCell>
                                          <TableCell align="right">{commune.effectif}</TableCell>
                                          <TableCell align="right">{commune.tailleMoyenne}</TableCell>
                                          <TableCell align="right">{commune.menageAgricole}</TableCell>
                                          <TableCell align="right">{commune.pourcentageAgricole}</TableCell>
                                          <TableCell align="right">{commune.menageNonAgricole}</TableCell>
                                          <TableCell align="right">{commune.pourcentageNonAgricole}</TableCell>
                                        </CommuneRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                     {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('bluetooth')}>
                        <ListItemIcon>
                          <Bluetooth fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Bluetooth</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'information */}
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      À propos des ménages agricoles
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      Un ménage agricole est défini comme un ménage où au moins un membre pratique l'agriculture, 
                      l'élevage ou une activité connexe comme source principale de revenus.
                    </Typography>
                    <Typography variant="body2" paragraph>
                      Les données montrent que <strong>{householdData.total.pourcentageAgricole}%</strong> des ménages burundais sont agricoles, 
                      avec une proportion plus élevée en milieu rural (<strong>{householdData.rural.pourcentageAgricole}%</strong>) 
                      qu'en milieu urbain (<strong>{householdData.urbain.pourcentageAgricole}%</strong>).
                    </Typography>
                    <Typography variant="body2">
                      La taille moyenne des ménages est de <strong>{householdData.total.tailleMoyenne}</strong> personnes, 
                      légèrement plus élevée en milieu rural (<strong>{householdData.rural.tailleMoyenne}</strong>) 
                      qu'en milieu urbain (<strong>{householdData.urbain.tailleMoyenne}</strong>).
                    </Typography>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population, de l'Habitat, de l'Agriculture et Elevage (RGPHAE) 
                    réalisé en 2024. Les chiffres incluent uniquement les ménages ordinaires (non collectifs). 
                    Un ménage est
                    </Typography>
                                    </Paper>
                                  </Grid>
                                </Grid>
                              </Container>
                            </ContentWrapper>
                          </MainContentWithDrawer>
                          
                          {/* Pied de page */}
                          <Footer />
                        </MainContainer>
                      );
                    };
                    
                    export default AgriculturalHouseholdsPageProvCom;